module.exports = __webpack_public_path__ + "static/media/expand.68f7d67a.jpg";